import { offersResponseSchema } from '@/api/offers/schemas';
import { apiRequest } from '@/api/utils/api';

export const getOffers = () => apiRequest({ url: '/offers', method: 'GET', schema: offersResponseSchema });
